import { Row, Col } from 'antd';
import { useEffect, useState } from 'react';
import axios from 'axios';

export type Props = {
  id?: string
};

const BannerbarPartner: React.FC<Props> = (props) => {
  const { id } = props;
  const [bannerData, setBannerData] = useState<any>([]);

  useEffect(() => {
    getBannerPartner();
  }, []);

  const getBannerPartner = async () => {
    const { data } = await axios.get(`/pages/publish/${id}`);
    setBannerData(data?.data.banner);
  };

  return (
    <>
      {bannerData.length > 0 ? (
        <div
          style={{
            maxWidth: '1200px',
            margin: '54px auto 0px auto',
          }}
        >
          <Row>
            <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <img
                  alt=''
                  src={bannerData}
                  style={{
                    maxWidth: '100%',
                    objectFit: 'contain',
                    height: 'auto',
                  }}
                />
            </Col>
          </Row>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default BannerbarPartner;
